module.exports = __webpack_public_path__ + "static/media/down_modal.e01582b7.png";